var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('loading',{attrs:{"active":_vm.isProcessing,"is-full-page":true,"loader":"dots"},on:{"update:active":function($event){_vm.isProcessing=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }